import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './icsi2ndMonth.scss';

export default function ICSI2ndMonth(props) {
  const [showTables, setShowTables] = useState({
    medication: true,
    investigations: true,
    obstetricHistory: true
  });
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [complaints, setComplaints] = useState('');
  const [otherComplaintSelected, setOtherComplaintSelected] = useState(false);

  const [obstetricHistoryRows, setObstetricHistoryRows] = useState([
    {
      g: '',
      outcome: '',
      modeOfConception: '',
      weeks: '',
      modeOfDelivery: '',
      babyOutcome: '',
      complications: '',
      comments: ''
    }
  ]);

  const obstetricHistoryHeaders = [
    {
      key: 'outcome',
      label: 'G Outcome',
      inputType: 'select',
      options: ['Term', 'Preterm', 'Miscarriage', 'Ectopic']
    },
    {
      key: 'modeOfConception',
      label: 'Mode of Conception',
      inputType: 'select',
      options: ['Natural', 'IUI', 'IVF']
    },
    {key: 'weeks', label: 'Weeks'},
    {
      key: 'modeOfDelivery',
      label: 'Mode of Delivery',
      inputType: 'select',
      options: ['Vaginal', 'LSCS', 'Medical', 'Surgical Miscarriage']
    },
    {
      key: 'babyOutcome',
      label: 'Baby Outcome',
      inputType: 'select',
      options: ['Alive', 'Expired', 'Other']
    },
    {
      key: 'complications',
      label: 'Complications',
      inputType: 'select',
      options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other']
    },
    {key: 'comments', label: 'COMMENTS'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'Folvista / Trafolic / Folinext Gold',
      genericName: 'Folic Acid',
      dosage: '1 TABLET',
      freq: '0-0-1 (Once Daily)',
      withFood: 'After Food',
      duration: '30 Days'
    },
    {
      sno: '2',
      drug: 'Vomibune',
      genericName: 'Doxylamine + Pyridoxine',
      dosage: 'Max 2 tabs x 3/day',
      freq: 'PRN (Up to TID)',
      withFood: 'Before Food',
      duration: 'SOS'
    },
    {
      sno: '3',
      drug: 'Evaraft',
      genericName: 'Sodium Alginate + Bicarbonate + CaCO₃',
      dosage: '10 mL',
      freq: 'Twice Daily PRN',
      withFood: 'After Food',
      duration: 'SOS'
    },
    {
      sno: '4',
      drug: 'Vivamom',
      genericName: 'Maternal Protein Supplement',
      dosage: '2 tsp',
      freq: 'Once/Twice Daily',
      withFood: 'With Milk, Between Meals',
      duration: '30 Days'
    },
    {
      sno: '5',
      drug: 'Dydrofirst / Dydraboone',
      genericName: 'Dydrogesterone',
      dosage: '10 mg',
      freq: '1-1-1',
      withFood: 'After Food',
      duration: '30 Days'
    },
    {
      sno: '6',
      drug: 'Progynova',
      genericName: 'Estradiol Valerate',
      dosage: '2 mg',
      freq: '1-0-1',
      withFood: 'After Food',
      duration: '5 Days / As Advised'
    },
    {
      sno: '7',
      drug: 'Strone AQ',
      genericName: 'Progesterone (Subcutaneous)',
      dosage: '50 mg',
      freq: '1-0-0',
      withFood: 'Subcutaneous – Morning',
      duration: 'As Advised'
    },
    {
      sno: '8',
      drug: 'C. Gestobond',
      genericName: 'Micronized Progesterone Vaginal Capsule',
      dosage: '400 mg',
      freq: '0-0-1 or BD Vaginally',
      withFood: '—',
      duration: '30 Days'
    },
    {
      sno: '9',
      drug: 'T. Ecospirin',
      genericName: 'Low-dose Aspirin',
      dosage: '75 mg',
      freq: '0-1-0',
      withFood: 'After Food',
      duration: '30 Days'
    },
    {
      sno: '10',
      drug: 'Evaparin',
      genericName: 'Enoxaparin 40 mg',
      dosage: '0.4 mL',
      freq: '1-0-0',
      withFood: 'Subcutaneous – Morning',
      duration: 'As Advised'
    },
    {
      sno: '11',
      drug: 'T.Ecosprin 75/150',
      genericName: 'Aspirin 75/150 mg',
      dosage: '1 tablet',
      freq: '0-1-0',
      withFood: 'Oral',
      duration: 'Till 34 weeks'
    }
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.NO'},
    {key: 'drug', label: 'DRUG NAME'},
    {key: 'genericName', label: 'GENERIC NAME'},
    {key: 'dosage', label: 'DOSAGE'},
    {key: 'freq', label: 'FREQUENCY'},
    {key: 'withFood', label: 'RELATION TO FOOD'},
    {key: 'duration', label: 'DURATION'}
  ];

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleTableRowsChange = (id, updatedRows) => {
    if (id === 'obstetricHistory') {
      setObstetricHistoryRows(updatedRows);
    }
  };

  const [investigationRows, setInvestigationRows] = useState([
    {name: 'Blood Group and Rh typing', value: ''},
    {name: 'Complete Blood Count (CBC)', value: ''},
    {name: 'TSH & Free T4', value: ''},
    {name: 'Urea, Creatinine', value: ''},
    {name: 'Random Blood Sugar / HbA1c / GCT (75g Glucose)', value: ''},
    {name: 'HIV, HBsAg, VDRL, Anti-HCV', value: ''},
    {name: 'Rubella IgG', value: ''},
    {name: 'Urine Routine and Culture', value: ''}
  ]);

  const investigationHeaders = [
    {key: 'name', label: 'Investigation'},
    {key: 'value', label: 'Result'}
  ];

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('icsi2ndMonthReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'ICSI 2 nd Month'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='ICSI2ndMonthTemplate'>
      <div className='ICSI2ndMonthTemplate'>
        <div style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>2-Month Antenatal Template – ASCAS</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='ET Date:' name='etDate' value={formData.etDate} required={false} onChange={handleChange} inputClassName='show' type='date' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='POG:' name='pog' value={formData.pog} required={false} onChange={handleChange} inputClassName='show' endLabel='Weeks' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='EDD:' name='edd' value={formData.edd} required={false} onChange={handleChange} inputClassName='show' type='date' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Previous Weight:'
                name='previousWeight'
                value={formData.previousWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='180px'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Complaints'
                name='complaints'
                value={formData.complaints}
                options={[
                  {label: 'Nausea/Vomiting', value: 'Nausea/Vomiting'},
                  {label: 'Bleeding', value: 'Bleeding'},
                  {label: 'Others', value: 'Others'}
                ]}
                onChange={e => {
                  handleChange(e);
                  setOtherComplaintSelected(e.target.value === 'Others');
                }}
                placeholder='Select Complaint'
              />
            </div>
            {otherComplaintSelected && (
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Other:' name='otherComplaintDescription' value={formData.otherComplaintDescription} required={false} onChange={handleChange} />
              </div>
            )}
          </div>

          <h4 className='mt-3'>Obstetric History:</h4>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='G:' name='g' value={formData.g} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='P:' name='p' value={formData.p} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='L:' name='l' value={formData.l} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='A:' name='a' value={formData.a} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='E:' name='e' value={formData.e} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          {showTables.obstetricHistory && (
            <TemplateTable
              id='obstetricHistory'
              headers={obstetricHistoryHeaders}
              rows={obstetricHistoryRows}
              onRowsChange={handleTableRowsChange}
              enableActions={true}
              onNill={() => handleNill('obstetricHistory', setShowTables)}
            />
          )}

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='scanFinding' className='fw-bold' style={{width: '180px'}}>
              🖥️ Scan Finding:
            </label>
            <textarea className='Textarea' placeholder='Scan Finding' id='scanFinding' name='scanFinding' onChange={handleChange} rows='5' cols='100' />
          </div>

          {showTables.investigations && (
            <TemplateTable
              id='investigations'
              title='✅ First Trimester Investigations'
              headers={investigationHeaders}
              rows={investigationRows}
              onRowsChange={(id, newRows) => setInvestigationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('investigations', setShowTables)}
            />
          )}
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='💊 Medications Advised'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='bulletin'>
          <h4>🚨 Bleeding Protocol</h4>
          <span>If bleeding or spotting occurs:</span>
          <ul className='ms-5'>
            <li>
              <b>Strict Bed Rest</b> for 5–7 days
            </li>
            <li>
              Continue all <b>progesterone supports</b>:
            </li>
            <ul>
              <li>
                <b>Dydrofirst/Dydraboone</b> (Oral, 1-1-1)
              </li>
              <li>
                <b>Strone AQ</b> (SC, daily)
              </li>
              <li>
                <b>Gestobond</b> (Vaginal, BD)
              </li>
            </ul>
            <li>
              Add <b>Tranexamic Acid 500 mg</b> – Oral, 1 tablet 2–3 times/day (if advised)
            </li>
            <li>
              <b>Continue Evaparin</b> unless advised to pause
            </li>
            <li>
              Avoid <b>travel, intercourse, exertion</b>
            </li>
            <li>Repeat scan if bleeding continues &gt;3–4 days</li>
            <li>
              Emergency Contact:<b> +91-9342521779</b>
            </li>
          </ul>
        </div>

        <div className='bulletin'>
          <h4>📝 Footnote</h4>
          <span>For high-risk or immune-based support, if advised by your consultant:</span>
          <ul>
            <li>
              <b>Intralipid infusion</b>
            </li>
            <li>
              <b>Bharglobin (IVIG)</b>
            </li>
          </ul>
        </div>

        <div className='d-flex align-items-start py-2'>
          <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
            ADVICE:
          </label>
          <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='3' cols='100'></textarea>
        </div>
        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='icsi2ndMonthReport'>
        <div id='icsi2ndMonthReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div className='patient' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '5px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>2-Month Antenatal Template – ASCAS</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('ET Date:', formData.etDate?.split('-').reverse().join('-'))}
            {renderReportfield('POG:', `${formData.pog || ''} Weeks`)}
            {renderReportfield('EDD:', formData.edd?.split('-').reverse().join('-'))}
            {renderReportfield('BP:', `${formData.bp || ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight || ''} kg`)}
            {renderReportfield('Previous Weight:', `${formData.previousWeight || ''} kg`)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Complaints:', formData.complaints)}
            {otherComplaintSelected && renderReportfield('Other:', formData.otherComplaintDescription)}
          </div>

          <div style={{fontWeight: 'bold'}}>Obstetric History:</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Obstetric Score: G', formData.g)}
            {renderReportfield('P', formData.p)}
            {renderReportfield('L', formData.l)}
            {renderReportfield('A', formData.a)}
            {renderReportfield('E', formData.e)}
          </div>
          {showTables.obstetricHistory &&
            renderDynamicTable(
              '',
              ['G Outcome', 'Mode of Conception', 'Weeks', 'Mode of Delivery', 'Baby Outcome', 'Complications', 'COMMENTS'],
              ['outcome', 'modeOfConception', 'weeks', 'modeOfDelivery', 'babyOutcome', 'complications', 'comments'],
              obstetricHistoryRows
            )}
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('🖥️ Scan Finding:', formData.scanFinding)}</div>

          {showTables.investigations && renderDynamicTable('✅ First Trimester Investigations', ['Investigation', 'Result'], ['name', 'value'], investigationRows)}

          {showTables.medication &&
            renderDynamicTable(
              '💊 Medications Advised',
              ['S.NO', 'DRUG NAME', 'GENERIC NAME', 'DOSAGE', 'FREQUENCY', 'RELATION TO FOOD', 'DURATION'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'withFood', 'duration'],
              medicationRows
            )}

          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 600}}>🚨 Bleeding Protocol</h6>
            <span style={{display: 'block', marginLeft: '20px'}}>If bleeding or spotting occurs:</span>
            <ol style={{marginLeft: '30px'}}>
              <li>
                <b>Strict Bed Rest</b> for 5–7 days
              </li>
              <li>
                Continue all <b>progesterone supports</b>:
                <ol>
                  <li>
                    <b>Dydrofirst/Dydraboone</b> (Oral, 1-1-1)
                  </li>
                  <li>
                    <b>Strone AQ</b> (SC, daily)
                  </li>
                  <li>
                    <b>Gestobond</b> (Vaginal, BD)
                  </li>
                </ol>
              </li>
              <li>
                Add <b>Tranexamic Acid 500 mg</b> – Oral, 1 tablet 2–3 times/day (if advised)
              </li>
              <li>
                <b>Continue Evaparin</b> unless advised to pause
              </li>
              <li>
                Avoid <b>travel, intercourse, exertion</b>
              </li>
              <li>Repeat scan if bleeding continues &gt;3–4 days</li>
              <li>
                Emergency Contact:<b> +91-9342521779</b>
              </li>
            </ol>
          </div>

          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 600}}>📝 Footnote</h6>
            <span style={{marginLeft: '20px'}}> For high-risk or immune-based support, if advised by your consultant:</span>
            <ol style={{marginLeft: '30px'}}>
              <li>
                <div>
                  <b>Intralipid infusion</b>
                </div>
              </li>
              <li>
                <div>
                  <b>Bharglobin (IVIG)</b>
                </div>
              </li>
            </ol>
          </div>

          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('ADVICE:', formData.advice)}</div>
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
